module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';

	var min_ratings = 1;
	if ( registry("Customer").Oberstdorf ) {
		min_ratings = 10;
	}

__p+='\n\n<section class="result-box hidden" data-id="'+
((__t=( result.id ))==null?'':__t)+
'">\n	\n	<div class="inner">\n		\n		';
 if ( result.rating > 0 && result.rating_count >= min_ratings ) { 
__p+='<div class="result-box-overlay-right">\n			<span class="digit">'+
((__t=( Math.round( result.rating ) ))==null?'':__t)+
'%</span> '+
((__t=( __('recommentation') ))==null?'':__t)+
'</div>';
 } 
__p+='\n\n		';
 var visibleResults = result.classes.filter(function(r) { return r.visible }) 
__p+='\n\n		<div class="slider ';
 if ( visibleResults.length <= 1 ) print('single') 
__p+='">\n\n			';
 _.each( visibleResults.reverse(), function(item) { 
__p+=' \n\n 				<div class="item" data-id="'+
((__t=( item.id ))==null?'':__t)+
'" data-item="'+
((__t=( item.item ))==null?'':__t)+
'">\n\n					<div class="image">\n						';
 if ( item.image && item.image != "0" ) { 
__p+='\n						<div class="inner" style="background-image: url(https://'+
((__t=( window.Tramino.cdn || 'tramino.s3.amazonaws.com' ))==null?'':__t)+
''+
((__t=( item.image ))==null?'':__t)+
')"></div>\n						';
 } 
__p+='\n					</div>\n\n 					';
 if ( item.stars ) { 
__p+='\n					<div class="stars">'+
((__t=( __("result_validated") ))==null?'':__t)+
'<br/>'+
((__t=( item.stars ))==null?'':__t)+
'</div>\n					';
 } 
__p+='\n\n					<div class="info">\n					\n						<div class="arrow prev"><div class="arrow-inner"></div></div>\n\n							';
 if ( item.price ) {  
__p+='\n								<div class="price" title="Gesamtpreis für alle Personen">\n									<span class="digits">'+
((__t=( Math.round( parseFloat(item.price) )  ))==null?'':__t)+
'</span><span class="currency">€</span>\n									';
 if ( result.booking == 1 ) { 
__p+='<div class="online-booking">'+
((__t=( __("result_book_online") ))==null?'':__t)+
'</div>';
 } 
__p+='\n								</div>\n							';
 } else { 
__p+='\n								<div class="price">\n								</div>\n							';
 } 
__p+='\n						<div class="text">\n							<div class="inner">\n								<b>'+
((__t=( item.name ))==null?'':__t)+
'</b>\n								<br/>\n								';
 if ( item.price ) {  
__p+='\n									';
 if ( item.inkl ) print(__('item_includes', { item: item.inkl }) ) 
__p+=' \n									';
 if ( Tramino.client != 620 ) { 
__p+='\n										';
 if ( item.inkl ) print(", ") 
__p+='\n										'+
((__t=( __('zzgl') ))==null?'':__t)+
'\n										';
 if ( tagSelected(1522) && ( ! ( item.inkl && item.inkl.match(/Frühstück|breakfast|Halbpension|¾|half|Vollpension|full/i  ) ) || ! item.inkl ) ) print(__('breakfast_charge')) 
__p+='\n										';
 if ( tagSelected(4598) && ( ! ( item.inkl && item.inkl.match(/Halbpension|¾|half/i ) ) || ! item.inkl ) ) print(__('halfboard_charge')) 
__p+='\n										';
 if ( tagSelected(8134) && ( ! ( item.inkl && item.inkl.match(/Vollpension|full/i ) ) || ! item.inkl ) ) print(__('fullboard_charge')) 
__p+='\n										'+
((__t=( __('spatax') ))==null?'':__t)+
'\n									';
 } 
__p+='\n									<br/>\n								';
 } 
__p+='\n							</div>\n						</div>\n\n						<div class="arrow next"><div class="arrow-inner"></div></div>\n\n					</div>\n\n				</div>\n\n			';
 }); 
__p+='\n\n		</div>\n\n		<div class="info bottom">\n\n			<div class="logo" >\n				<div class="inner">\n				';
 if ( result.logo && result.logo != 0 ) { 
__p+='\n				<img src="https://'+
((__t=( window.Tramino.cdn || 'tramino.s3.amazonaws.com' ))==null?'':__t)+
''+
((__t=( result.logo ))==null?'':__t)+
'" width="200" height="150">\n				';
 } 
__p+='\n				</div>\n			</div>\n\n			<div class="text">\n				<h2 '+
((__t=( ( result.name.length > 25 ) ? 'class="longname"' : '' ))==null?'':__t)+
' ><a href="'+
((__t=( registry('PartnerBase') ))==null?'':__t)+
''+
((__t=( result.shortcut ))==null?'':__t)+
'.html">'+
((__t=( result.name ))==null?'':__t)+
'</a></h2>\n				<h3 class="color">'+
((__t=( result.slogan ))==null?'':__t)+
'</h3>\n				<div class="foot">\n					<div class="address">'+
((__t=( result.street ))==null?'':__t)+
'';
 if (result.district) print( "<span class='district'>, " + result.district + "</span>") 
__p+='</div>\n					<div class="phone">\n						'+
((__t=( __('Tel.') ))==null?'':__t)+
' '+
((__t=( result.phone ))==null?'':__t)+
'\n					</div>\n				</div>\n			</div>\n\n			';
 if ( favorited ) { 
__p+='\n			<div class="favable on" data-item="clients-'+
((__t=( result.id ))==null?'':__t)+
'" title="'+
((__t=( __('unlike') ))==null?'':__t)+
'"></div>\n			';
 } else { 
__p+='\n			<div class="favable" data-item="clients-'+
((__t=( result.id ))==null?'':__t)+
'" title="'+
((__t=( __('like') ))==null?'':__t)+
'"></div>\n			';
 } 
__p+='\n\n			<div class="clear"></div>\n\n		</div>\n	</div>\n\n</section>\n\n';
}
return __p;
};


//////////////////
// WEBPACK FOOTER
// /Users/bm/app/code/jsapps/modules/reserva/templates/engine/result-template.html
// module id = 62
// module chunks = 0